import { RvaiExceptions } from '@robovision/rvai-base'


class LicenseExpired extends Error {}

class NestedError extends Error {
  public error: Error
  constructor (message: string, error: Error) {
    super(message)
    this.error = error
  }
}

class ProjectNotFound extends RvaiExceptions.NotFound {}

class JobDefinitionNotFound extends RvaiExceptions.NotFound {}

class TermsAndConditionsNotAccepted extends Error {}

class InjectionFailed extends Error {
  constructor (subjectName: string) {
    super(`Invalid use of 'use${subjectName}'. Did you forget to use 'provide${subjectName}'?`)
  }
}

export const Exceptions = {
  CancelAsync: RvaiExceptions.CancelAsync,
  HttpsProtocolMismatch: RvaiExceptions.HttpsProtocolMismatch,
  InjectionFailed,
  JobDefinitionNotFound,
  LicenseExpired,
  NestedError,
  NotFound: RvaiExceptions.NotFound,
  ProjectNotFound,
  TermsAndConditionsNotAccepted,
  Unauthorized: RvaiExceptions.Unauthorized,
}
